import React from "react";

export default function BenefitBulletList({ items }) {
  return (
    <ul className="fire-explosion__benefit-list">
      {items.map((text, i) => (
        <li key={i} className="fire-explosion__benefit-item">
          <span className="fire-explosion__benefit-check" aria-hidden>
            ✓
          </span>
          <span className="fire-explosion__benefit-item-text">{text}</span>
        </li>
      ))}
    </ul>
  );
}
